export class AirlineView {
    constructor(
      public airlineId: number,
      public airlineCode: string,
      public airlineName: string,
      public carrier: string,
    ) { }
}